var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-group"},[_vm._l((_vm.computeOnlyIds),function(volume){return _c('compute-volume',{key:("compute:" + volume),attrs:{"volume-id":("compute:" + volume)}})}),_vm._v(" "),_vm._l((_vm.volumeContainerIds),function(volume){return _c('compute-volume',{key:volume,attrs:{"volume-id":volume}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35f5a5d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/ComputeVolumes.vue
// module id = YvPX
// module chunks = 1